import React, { Fragment, useEffect, useState } from "react";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import { Divider, Grid, InputAdornment, TextField } from "@mui/material";

const SearchBar = ({
  searchText,
  onSearch,
  selectedCount,
  onBulkStatusChange,
  onDuplicate,
}) => {
  const [statusOptions, setStatusOptions] = useState(false);

  useEffect(() => {
    if (selectedCount < 1) {
      setStatusOptions(false);
    }
  }, [selectedCount]);

  return (
    <Grid container alignItems={"center"} style={{ marginBottom: 10 }}>
      <TextField
        variant="outlined"
        placeholder={"Search templates..."}
        value={searchText}
        onChange={(e) => onSearch(e.target.value)}
        InputProps={{
          sx: { ...searchTextfieldStyles },
          startAdornment: (
            <InputAdornment position="start">
              <SearchOutlinedIcon />
            </InputAdornment>
          ),
        }}
      />

      {selectedCount > 0 && (
        <Fragment>
          <span style={selectedItemsStyles}>{selectedCount} selected</span>
          <TrendingFlatIcon fontSize="large" style={{ color: "#242424" }} />

          <span
            style={{
              ...statusTextSTyles,
              color: statusOptions ? "#9447AF" : "#00A7CD",
            }}
            onClick={() => {
              setStatusOptions(true);
            }}
          >
            Status
          </span>

          {statusOptions && (
            <Fragment>
              <TrendingFlatIcon
                fontSize="medium"
                style={{ color: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => onBulkStatusChange("active")}
              >
                Active
              </span>
              <Divider
                orientation="vertical"
                style={{ height: 15, borderColor: "#919191" }}
              />
              <span
                style={statusTextSTyles}
                onClick={() => onBulkStatusChange("inactive")}
              >
                Inactive
              </span>
            </Fragment>
          )}

          <Divider
            orientation="vertical"
            style={{ height: 25, borderColor: "#000" }}
          />

          <span style={statusTextSTyles} onClick={onDuplicate}>
            Duplicate
          </span>
        </Fragment>
      )}
    </Grid>
  );
};

export default SearchBar;

// Match OrganizationQuickTales SearchBar styling
const searchTextfieldStyles = {
  height: 40,
  border: "none",
  borderColor: "#7676801F",
  borderRadius: 5,
  width: 270,
  background: "#7676801F",
  color: "#515563",
  fontSize: 14,
  fontWeight: 500,
  paddingLeft: 1,
  paddingRight: 2,
  fontFamily: "Avenir Book, sans-serif",
};

const selectedItemsStyles = {
  color: "#020303",
  marginLeft: 10,
  marginRight: 10,
  fontSize: 14,
  fontWeight: 500,
  fontFamily: "Avenir Book, sans-serif",
};

const statusTextSTyles = {
  color: "#00A7CD",
  marginLeft: 10,
  marginRight: 10,
  fontSize: 14,
  fontWeight: 500,
  cursor: "pointer",
  fontFamily: "Avenir Book, sans-serif",
};

